import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CDMS_STUDY_SUBJECT_LANG: {
  CDMS_STUDY_SUBJECT_PAGE_TITLE: MvnCodeFE;
  CDMS_STUDY_SUBJECT_PAGE_DESC: MvnCodeFE;
  CDMS_STUDY_SUBJECT_PRESUBJECT_PAGE_TITLE: MvnCodeFE;
  CDMS_STUDY_SUBJECT_PRESUBJECT_PAGE_DESC: MvnCodeFE;
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_BTN: MvnCodeFE;
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_SUCC: MvnCodeFE;
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_FAIL: MvnCodeFE;
  CDMS_SUBJECT_BULK_ADD_DIALOG_DESC: MvnCodeFE;
  CDMS_SUBJECT_BULK_ADD_DIALOG_INVALID_COUNTS_DESC: MvnCodeFE;
  CDMS_SUBJECT_CONTACT_NOT_EXIST: MvnCodeFE;
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_INCOMPLETE: MvnCodeFE;
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_PARTIALLY_COMPLETE: MvnCodeFE;
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_COMPLETE: MvnCodeFE;
  CDMS_SUBJECT_CRF_STATUS_LOCKING: MvnCodeFE;
  CDMS_SUBJECT_CRF_STATUS_LOCKING_FAIL: MvnCodeFE;
  CDMS_SUBJECT_CRF_STATUS_UNLOCKING: MvnCodeFE;
  CDMS_SUBJECT_CRF_STATUS_UNLOCKING_FAIL: MvnCodeFE;
} = {
  CDMS_STUDY_SUBJECT_PAGE_TITLE: {
    ko: "Subject",
    en: "Subject",
  },
  CDMS_STUDY_SUBJECT_PAGE_DESC: {
    ko: "등록된 대상자를 확인하고 데이터를 수집할 수 있습니다.",
    en: "Manage registered subjects and collect study data.",
  },
  CDMS_STUDY_SUBJECT_PRESUBJECT_PAGE_TITLE: {
    ko: "Pre Subject",
    en: "Pre Subject",
  },
  CDMS_STUDY_SUBJECT_PRESUBJECT_PAGE_DESC: {
    ko: "등록된 임시 대상자를 확인하고 데이터를 수집할 수 있습니다.",
    en: "Manage registered pre subjects and collect study data.",
  },
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_BTN: {
    ko: "Add to Subject",
    en: "Add to Subject",
  },
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_SUCC: {
    ko: "Subject 전환에 성공하였습니다.",
    en: "Subject successfully added.",
  },
  CDMS_STUDY_SWITCH_PRESUBJECT_TO_SUBJECT_FAIL: {
    ko: "Subject 전환에 실패하였습니다. ({message})",
    en: "Failed to add subject. ({message})",
  },
  CDMS_SUBJECT_BULK_ADD_DIALOG_DESC: {
    ko: "Subject는 한번에 최대 {count}명까지 일괄 등록 가능합니다.",
    en: "Subjects can be registered up to {count} at a time. ",
  },
  CDMS_SUBJECT_BULK_ADD_DIALOG_INVALID_COUNTS_DESC: {
    ko: "{count}명 이하로 입력해 주세요.",
    en: "Please enter the number of subjects less than {count}.",
  },
  CDMS_SUBJECT_CONTACT_NOT_EXIST: {
    ko: "Subject 전화번호가 설정되지 않았습니다. 전화번호 설정 후 다시 시도해 주십시오.",
    en: "Subject phone number has not been entered. Please try again after setting the phone number.",
  },
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_INCOMPLETE: {
    ko: "미완료",
    en: "Incomplete",
  },
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_PARTIALLY_COMPLETE: {
    ko: "부분 완료",
    en: "Partially complete",
  },
  CDMS_SUBJECT_STATUS_INDEPENDENT_EVALUATION_COMPLETE: {
    ko: "완료",
    en: "Complete",
  },
  CDMS_SUBJECT_CRF_STATUS_LOCKING: {
    ko: "Locking 처리되었습니다.",
    en: "Locking processed successfully.",
  },
  CDMS_SUBJECT_CRF_STATUS_LOCKING_FAIL: {
    ko: "Locking 처리에 실패하였습니다. ({message})",
    en: "Failed to lock. ({message})",
  },
  CDMS_SUBJECT_CRF_STATUS_UNLOCKING: {
    ko: "Unlocking 처리되었습니다.",
    en: "Unlocking processed sucessfully.",
  },
  CDMS_SUBJECT_CRF_STATUS_UNLOCKING_FAIL: {
    ko: "Unlocking 처리에 실패하였습니다. ({message})",
    en: "Failed to unlock. ({message})",
  },
};

MvnCodeInitiate(CDMS_STUDY_SUBJECT_LANG);
